import { DecimalPipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReportSortService } from 'src/app/reports/services/report-sort.service';
import { getReportSort } from 'src/app/store/selectors';

import { GroupedCropField } from '../../models';

import { getGroupedCropFields } from './../../../registration/store/selectors/crop-field.selectors';

@Component({
  selector: 'app-cropfield-data',
  templateUrl: './cropfield-data.component.html',
  styleUrls: ['./cropfield-data.component.scss'],
  standalone: false,
})
export class CropFieldDataComponent {
  readonly store = inject(Store);
  private readonly locale = inject(LocaleService);
  private readonly sortService = inject(ReportSortService);
  protected decimalPipe = inject(DecimalPipe);

  @Input() print = '';
  reportSort$ = this.store.pipe(select(getReportSort));
  public groupedCropFields$ = this.store.pipe(select(getGroupedCropFields));
  public mainGroupedCropFields$ = this.sort(
    this.groupedCropFields$.pipe(map((groupedCropFields) => groupedCropFields.mainCultivations)),
  );
  public subsequentGroupedCropFields$ = this.sort(
    this.groupedCropFields$.pipe(
      map((groupedCropFields) => groupedCropFields.subsequentCultivations),
    ),
  );
  cultivationTitle: string;
  subsequentCultivationTitle: string;

  constructor() {
    const decimalPipe = this.decimalPipe;

    this.groupedCropFields$.subscribe((grouped) => {
      let cultivation = this.locale.translate('mainCultivation');
      let fieldTranslation =
        grouped.mainCultivationsTotalFields === 1
          ? this.locale.translate('field')
          : this.locale.translate('fields');
      this.cultivationTitle = `${cultivation} (${grouped.mainCultivationsTotalFields}
 ${fieldTranslation}, ${decimalPipe.transform(grouped.mainCultivationsTotalHa, '1.0-2')} ha)`;

      cultivation = this.locale.translate('subsequentCultivation');
      fieldTranslation =
        grouped.subsequentCultivationsTotalFields === 1
          ? this.locale.translate('field')
          : this.locale.translate('fields');
      this.subsequentCultivationTitle = `${cultivation} (${
        grouped.subsequentCultivationsTotalFields
      }
 ${fieldTranslation}, ${decimalPipe.transform(grouped.subsequentCultivationsTotalHa, '1.0-2')} ha)`;
    });
  }

  private sort(cropFields$: Observable<GroupedCropField[]>): Observable<GroupedCropField[]> {
    return combineLatest([cropFields$, this.reportSort$]).pipe(
      map(([cropFields, reportSort]) =>
        cropFields && reportSort
          ? this.sortService.sort({
              elements: cropFields,
              option: reportSort.option,
              descending: reportSort.descending,
              cropFieldNameFunc: (g) =>
                [...g.cropFields]
                  .map((f) => f.name)
                  .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1))[0],
              cropNameFunc: (g) => g.cropName,
            })
          : [],
      ),
    );
  }
}
